import React from 'react';
import Script from 'next/script';
import { useRouter } from 'next/router';

function ParceirosPromoV2Component() {
  const router = useRouter();

  const { Pid } = router.query;

  return Pid ? (
    <Script
      id="pp-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(c,o,m,r,a,d,e){
          r=o.createElement('script');r.async=1;r.src='https://cmp.pcr.rec.br/cmp'+c.location.search;
          r.id="cmp";a=o.getElementsByTagName('script')[0];a.parentNode.insertBefore(r,a);
          d=o.createElement('input');d.type='hidden';d.id='eh';d.value=m;
          e=o.getElementsByTagName('body')[0];e.appendChild(d);
          })(window,document,'${process.env.PARCEIROSPROMO_HASH_PLATAFORMA}');

          const url = new URL(window.location.href);
          const pid = atob(url.searchParams.get('Pid'));
          const urlParams = new URLSearchParams(pid);

          const pa_data = {
            pcrid: urlParams.get('pcrid'),
            utm_source: urlParams.get('utm_source'),
            utm_medium: urlParams.get('utm_medium'),
            pcrtt: urlParams.get('pcrtt'),
          };

          if (pa_data.pcrid) {
            let date = new Date();
            date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));

            let expires = "; expires=" + date.toGMTString();

            document.cookie = "pp=" + escape(JSON.stringify(pa_data)) + expires + "; path=/";
          }
        `,
      }}
    />
  ) : null;
}

export default ParceirosPromoV2Component;
